export default __webpack_public_path__ + "static/Office_image_4-944ef365d9b81c3c558f9259a8faa878.png";